import { useContext } from "react";
import { PsstContext } from "../contexts/psst.context";

const usePsst = () => {
  return useContext(PsstContext)
}

export default usePsst;